import { useQuery } from '@tanstack/react-query';
import { ShopTypes } from '~/lib/data-contract';
import useBasket from '~/services/shop/hooks/basket/useBasket';
import useBasketReference from '~/services/shop/hooks/selectors/basket/useBasketReference';
import { getDeliveryOptions } from '../../operations/basket';

export default function useDeliveryOptions(deliveryId: number) {
    const { data: reference } = useBasketReference();
    const { data: totalPrice } = useBasket((basket) => basket.total.priceInclVat);

    return useQuery<ShopTypes.DeliveryOptionsResponse, Error>(
        ['deliveryOptions', { reference, deliveryId, totalPrice }],
        () => getDeliveryOptions(reference, deliveryId),

        {
            enabled: !!reference,
        },
    );
}
